import { Controller } from "stimulus"
import 'devbridge-autocomplete/dist/jquery.autocomplete'

// Birth commune autocomplete: searches the referential (JSON endpoint), stores
// the INSEE code in a hidden field and shows the label in the visible input.
// Modeled on doctor-input-controller.
export default class extends Controller {
    static targets = ["search", "code", "change"]

    connect() {
        this.configureAutoComplete();
        this.refresh();
    }

    configureAutoComplete() {
        $(this.searchTarget).autocomplete({
            minChars: 3,
            maxHeight: 220,
            serviceUrl: this.searchTarget.dataset.url,
            dataType: 'json',
            paramName: 'q',
            deferRequestBy: 50,
            showNoSuggestionNotice: true,
            noSuggestionNotice: this.searchTarget.dataset.noResults,
            onSelect: (suggestion) => {
                this.codeTarget.value = suggestion.data;
                this.searchTarget.value = suggestion.value;
                this.refresh();
            }
        });
    }

    // Text left in the input without picking a suggestion has no INSEE code
    // behind it: drop it on blur. The plugin keeps its suggestions alive 200ms
    // after the blur to let a click through, so clear just after that.
    clearWhenUnselected() {
        setTimeout(() => {
            if (this.hasCodeTarget && !this.codeTarget.value) {
                this.searchTarget.value = '';
            }
        }, 250);
    }

    refresh() {
        if (this.codeTarget.value) {
            this.searchTarget.disabled = true;
            if (this.hasChangeTarget) this.changeTarget.style.display = 'inline';
        } else {
            this.searchTarget.disabled = false;
            if (this.hasChangeTarget) this.changeTarget.style.display = 'none';
        }
    }

    change(event) {
        event.preventDefault();
        $(this.searchTarget).autocomplete('hide');
        this.codeTarget.value = '';
        this.searchTarget.value = '';
        this.searchTarget.disabled = false;
        this.refresh();
        this.searchTarget.focus();
    }
}
